import ManageBillingAccount from 'components/BillingAccounts/ManageBillingAccount/ManageBillingAccount.vue';
import MyBillingAccounts from 'components/BillingAccounts/MyBillingAccounts/MyBillingAccounts.vue';
import LoginCard from 'components/Profile/LoginCard/LoginCard.vue';
import PasswordResetConfirm from 'components/Profile/PasswordReset/PasswordResetConfirm/PasswordResetConfirm.vue';
import PasswordResetRequest from 'components/Profile/PasswordReset/PasswordResetRequest/PasswordResetRequest.vue';
import TwoFactorAuthentication from 'components/Profile/PhoneNumber/LoginPhoneVerification.vue';
import ProfilePage from 'components/Profile/ProfilePage/ProfilePage.vue';
import Register from 'components/Profile/Register/Register.vue';
import SmartdataLanding from 'components/Landing/SmartdataLanding.vue';
import SupportPage from 'components/SupportPage/SupportPage.vue';
import { createApp } from 'vue';
import mainMixin, { registerApp } from 'js/mixins/mainMixin';

const mountEl = document.querySelector('#MainApp');
if (mountEl) {
    const app = createApp({
        components: {
            LoginCard,
            SupportPage,
            MyBillingAccounts,
            ManageBillingAccount,
            PasswordResetConfirm,
            PasswordResetRequest,
            Register,
            SmartdataLanding,
            ProfilePage,
            TwoFactorAuthentication,
        },
        mixins: [mainMixin],
        data() {
            return {
                pageName: 'Generic Page',
            };
        },
        computed: {},
        watch: {},
        mounted() {},
        methods: {},
    });
    registerApp(app);
    app.mount(mountEl);
}
